import * as React from "react";
function SvgUserFill(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <ellipse cx={9.93} cy={5.01} rx={5} ry={5.01} />
      <path d="M10.2 11.1h-.4a8.83 8.83 0 00-8.54 7.62A1.12 1.12 0 002.2 20h15.43a1.12 1.12 0 001.12-1.12v-.16a8.83 8.83 0 00-8.55-7.62z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserFill);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
